



































































































import axios from 'axios';
import Vue from 'vue';
import ClientForm from '@/components/ClientForm.vue';
import _ from 'lodash';

export default Vue.extend({
    components: {
        ClientForm
    },
    data() {
        return {
            isComponentModalActive: false,
            client: null as Client | null,
            columns: [
                // {
                //   field: '_id',
                //   label: 'ID',
                //   width: '40',
                // },
                {
                field: 'name',
                label: 'Name',
                },
                {
                width: '200',
                field: 'actions',
                label: 'Actions',
                }
            ],
            formProps: {
                name: ''
            },
            clients: [] as any[],
            isShowDeleteDialog: false
        }
    },
    async mounted() {
        this.$store.commit("APP_CLASSES", )
        this.$store.commit("TITLE_BAR", 'Clients')
        await this.getClients();
    },
    beforeMount() {
        document.title = 'Clients'
    },
    computed: {
        sortedClientList(): any[] {
            return _.sortBy(this.clients, ['name']);
        }
    },
    methods: {
        async getClients() {
            try {
                const result = await axios.get(`/clients`);
                this.clients = result.data;
                // this.$store.commit('REMOVE_CLIENT', { client });
            } catch (e) {
                // this.$dialog.alert({
                //   title: 'Error',
                //   message: `Failed to delete client ${client.name}. <br />${e}`,
                // })
            }
        },
        viewClient(client: Client) {
            this.$router.push(`/clients/${client.id}`);
        },
        async remove() {
            try {
                await axios.delete(`/clients/${this.client?.id}`);
                const index = this.clients.indexOf(this.client);
                this.clients.splice(index, 1);

                this.isShowDeleteDialog = false;
                this.client = null;
            } catch (e) {
                console.error(e);
            }
        },
        confirmRemove(client: Client) {
            this.client = client;
            this.isShowDeleteDialog = true;
            //   this.$dialog.alert({
            //     title: 'Delete Client',
            //     message: `Are you sure you want to delete ${client.name}?`,
            //     confirmText: 'Delete',
            //     cancelText: 'Cancel',
            //     canCancel: true,
            //     onConfirm: async () => { await this.remove(client); }
            //   });
        },
        async save(client: Client) {
            try {
                if (client.id) {
                    const result = await axios.put(`/clients/${client.id}`, client);
                    const index = this.clients?.indexOf(client);
                    this.clients.splice(index, 1, result.data);
                } else {
                    const result = await axios.post("/clients", client);
                    this.clients.push(result.data);
                }

                this.isComponentModalActive = false;
            } catch (e) {
                console.log("error", e)
            }
        },
        edit(client: Client) {
            this.client = client;
            this.isComponentModalActive = true;
        },
        closeModal() {
            this.isComponentModalActive = false;
            this.client = null;
        }
    }
});
